module.exports = __webpack_public_path__ + "img/ie.7041439e.svg";